function partialemail(email) {
  return email?.replace(/(\w{2})[\w.-]+@([\w.]+\w)/, "$1***@$2")
}

export default partialemail